<template>
  <div>
    <b-card-body v-if="!wait">
      <b-card>
        <div class="analyse-description">
          <div>
            <label class="mr-3 bold">{{ $t('productTitle') }}</label>
            <p v-if="products.length">{{ products[0].description }}</p>
          </div>
          <div>
            <label class="mr-3 bold">{{ $t('processTitle') }}</label>
            <p v-if="process.length">{{ process[0].description }}</p>
          </div>
          <div>
            <label class="mr-3 bold">{{ $t('occurrenceDetailsEquipment') }}</label>
            <p v-if="equipments.length">{{ equipments[0].description }}</p>
          </div>
        </div>
        <label class="mr-3 date-item d-flex bold">{{ $t('data-hora-da-analise') }} </label
        ><label>{{ analysisSelected.analysisTimestamp }}</label>
        <div>
          <div class="mt-2">
            <label class="mr-3 bold">{{ $t('grandezas-0') }}</label>
            <div class="gridGreatness grid1 middle"></div>
          </div>
        </div>
        <div class="groupBtn mt-4">
          <img
            src="@/assets/salvar.png"
            :alt="$t('salvar')"
            style="margin-left: 20px"
            :title="$t('salvar')"
            @click="addAnalysis"
          />
          <img
            id="closeModalPassword"
            class="float-right"
            src="@/assets/sair.png"
            style="margin-right: 15px; margin-left: 20px"
            :title="$t('sair')"
            :alt="$t('sair')"
            @click="$bvModal.hide('AnalysisDetails')"
          />
        </div>
      </b-card>
    </b-card-body>
    <b-card-body v-else>
      <p>{{ $t('carregando-os-dados-da-analise') }}</p>
    </b-card-body>
  </div>
</template>

<script>
import axios from "axios";
import * as cGridAll from "vue-cheetah-grid";
import * as cheetahGrid from "cheetah-grid";
import { AnalysisDataMixin } from "./AnalysisDataMixin";
import { FiltersMixin } from "../mixins/filtersMixin";
import { urlMainAPI, defaultSuccess, emitEventBuss } from "@/global";

var inputEditor = new cheetahGrid.columns.action.InlineInputEditor();

const { INPUT_CELL } = cheetahGrid.ListGrid.EVENT_TYPE;

export default {
  name: "analysisDetails",

  props: {
    analysisSelected: Object,
  },

  components: { ...cGridAll },

  mixins: [ AnalysisDataMixin, FiltersMixin ],

  data() {
    return {
      wait: false,
      analysis: {},
      products: [],
      process: [],
      equipments: [],
      greatness: [],
      greatnessToAnalysis: [],
      formatedDate:"",
      header: [
        {
          field: "nameAndUnit",
          caption: this.$t('nome-unidade-de-medida'),
          action: "text",
          width: "50%",
          maxWidth: "100%",
          headerStyle: { textAlign: "justify", font: "15px sans-serif" },
          style: { textOverflow: "elipse",  color:"#00000098" },
        },
        {
          field: "range",
          caption: this.$t('range-de-operacao'),
          action: "text",
          width: "25%",
          maxWidth: "50%",
          headerStyle: { textAlign: "justify", font: "15px sans-serif" },
          style: { textOverflow: "elipse", textAlign: "center", color:"#00000098" },
        },
        {
          field: "value",
          caption: this.$t('valor'),
          action: inputEditor,
          width: "23%",
          maxWidth: "46%",
          headerStyle: { textAlign: "justify", font: "15px sans-serif" },
          style(rec) {
            let checkValue = (value) => {
              if (value || value == 0) {
                return parseFloat(value.replace(",", "."));
              }
            };

            let range = [];
            let min = "";
            let max = "";
            let value = 0;

            if (rec.range.includes(" - ")) {
              range = rec.range.split(" - ");
              if (range.length == 2) {
                min = checkValue(range[0]);
                max = checkValue(range[1]);
              }
            } else {
              if (rec.range.includes("<=")) {
                max = rec.range.split("<= ")[1];
              } else {
                min = rec.range.split(">= ")[1];
              }
            }
            value = checkValue(rec.value);

            if ((min != "" && value < min) || (max != "" && value > max)) {
              return {
                color: "red",
                font: "18px sans-serif",
                textAlign: "center",
              };
            }
            return { textAlign: "center" };
          },
          message(rec) {
            if (isNaN(parseFloat(rec.value)) && rec.value && rec.value != 0)
              return "Por favor, digite apenas número.";
            return null;
          },
        },
      ],
    };
  },

  methods: {
    async loadAnalysisDetails() {
      this.wait = true;

      const analysisInf = {
        productId: this.analysisSelected.productId,
        processId: this.analysisSelected.processId,
        equipmentId: this.analysisSelected.equipmentId,
        analysisTimestamp: this.analysisSelected.analysisTimestamp.replaceAll("/", "-"),
      };

      const url = `${urlMainAPI}/getanalysisdata`;
      await axios
        .post(url, analysisInf)
        .then(async (res) => {
          if (res.data) {
            this.greatness = res.data;
          } else this.analysis = {};

          this.wait = false;
        })
        .catch(console.log);

      for (let index = 0; index < this.greatness.length; index++) {
        let analyse = {};
        analyse.nameAndUnit = `${this.greatness[index].name} (${this.greatness[index].unit})`;

        let range =
          this.greatness[index].lowerThreshould == -9999
            ? `<= ${this.greatness[index].upperThreshould}`
            : "";
        range =
          this.greatness[index].upperThreshould == -9999
            ? `>= ${this.greatness[index].lowerThreshould}`
            : range;
        range =
          range == ""
            ? `${this.greatness[index].lowerThreshould} - ${this.greatness[index].upperThreshould}`
            : range;
        analyse.range = range;
        analyse.value = !this.greatness[index].value
          ? ""
          : this.greatness[index].value.toString();
        let product = {
          id: this.greatness[index].productId,
          description: this.greatness[index].product,
        };
        let process = {
          id: this.greatness[index].processId,
          description: this.greatness[index].process,
        };
        let equipment = {
          id: this.greatness[index].equipmentId,
          description: this.greatness[index].equipment,
        };

        this.products.push(product);
        this.process.push(process);
        this.equipments.push(equipment);
        this.analysisSelected.analysisTimestamp =
          this.greatness[index].analysisTimestamp;

        this.greatnessToAnalysis.push(analyse);
      }
    },

    addAnalysis() {
      let analysesData = [];

      this.greatnessToAnalysis.forEach((gta) => {
        if (gta.nameAndUnit != null) {
          let analysisToSave = {
            productId: this.analysisSelected.productId,
            equipmentId: this.analysisSelected.equipmentId,
            processId: this.analysisSelected.processId,
            greatness:
              gta.nameAndUnit.split(" (")[0] == ""
                ? "PROD-GREATNESS-1"
                : gta.nameAndUnit.split(" (")[0],
            analysisTimestamp: this.analysisSelected.analysisTimestamp,
            value:
              gta.value == undefined
                ? null
                : parseFloat(gta.value.replace(",", ".")),
          };
          analysesData.push(analysisToSave);
        }
      });

      if (!this.canSave(analysesData, 0)) return;

      const url = `${urlMainAPI}/saveanalysisdata`;

      defaultSuccess(this.$t('atualizando-dados'));
      axios.post(url, analysesData).then(() => {
        defaultSuccess(this.$t('dados-atualizados-com-sucesso'));
        this.$bvModal.hide('AnalysisDetails');
      });
    },

    createGrid() {
      const grid = new cheetahGrid.ListGrid({
        parentElement: document.querySelector(".gridGreatness"),
        allowRangePaste: true,
        header: this.header,
      });

      grid.records = this.greatnessToAnalysis;

      grid.listen(INPUT_CELL, (...args) => {
        if (
          args[0].row == this.greatness.length &&
          !this.greatness[this.greatness.length - 1].name
        ) {
          this.setGrid();
        }
      });

      this.setGrid = function (table = this.greatnessToAnalysis) {
        if (table.length > 0 && !table[table.length - 1].nameAndUnit)
          this.addLine();
        grid.records = table;
      };
    },

    addLine(param) {
      this.greatnessToAnalysis.push({
        nameAndUnit: param,
        range: "",
        value: null,
      });
    },
  },

  async created() {
    await this.loadAnalysisDetails();
    this.createGrid();
  },

  destroyed() { 
    this.wait = false;
    emitEventBuss("reloadGridAnalysis")
  }
};
</script>

<style scoped>
.grid1 {
  height: calc(63vh - 220px);
  width: 100%;
  border: solid 1px rgba(0, 0, 0, 0.26);
  overflow-x: hidden;
  overflow-y: auto;
}

.row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 30px;
}

.group {
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 20px;
}

.gridBtGroup {
  margin: 30px auto auto auto;
  width: 80vw;
  display: flex;
  justify-content: flex-end;
}

.ybase {
  /* margin-right: 20px; */
  margin-top: 20x;
}

.gridBtGroup img {
  cursor: pointer;
  max-height: 45px;
}

/* Copiando a FaultTreeManagement */

.table,
.indicator-select,
.fault-tree {
  max-height: 155px;
  overflow-x: auto;
  border: 1px solid #00000013;
  border-radius: 4px;
  box-shadow: 2px 2px 2px #00000013;
}

.fault-tree {
  overflow-x: none;
  max-height: 600px;
  padding: 10px;
}

.indicator-select {
  margin-bottom: 15px;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

img,
.copy {
  cursor: pointer;
  max-height: 35px;
}

.copy {
  height: 35px;
  width: 35px;
  color: #ff7100;
  transition-delay: 600ms;
}

.field-selected {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 15px;
  max-height: 100px;
  overflow-y: auto;
}

.lines-selected {
  background-color: #00000013;
  padding: 0 3px;
  margin: 2px 5px;
  border-radius: 3px;
}

.btn-clear {
  cursor: pointer;
}

.alignFlex {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 55%;
}

.analyse-description {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.33%;
}

.bold {
  font-weight: bold;
}
</style>